import React from "react";
import { Helmet } from "react-helmet-async";
import ResumePage from "./Resume";

const ResumePrivate = () => (
  <>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <title>Chintan Tank | Resume (Private)</title>
    </Helmet>
    <ResumePage email="tankchintan@gmail.com" />
  </>
);

export default ResumePrivate;
